import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './App.scss';
import Routes from './components/Routes';
import { TranslationProvider } from './hooks/use-translation';
import { LoadingProvider } from './hooks/use-loader';
import { SnackBarProvider } from './hooks/use-snackbar';
import SnackBar from './components/snackbar';
import CacheBuster from './components/CacheBuster';

export default () => (
  <CacheBuster>
    {({ loading, isLatestVersion, refreshCacheAndReload }) => {
      if (loading) return null;
      if (!loading && !isLatestVersion) {
        refreshCacheAndReload();
      }

      return (
        <>
          <LoadingProvider>
            <TranslationProvider>
              <SnackBarProvider>
                <SnackBar />
                <Router>
                  <Routes />
                </Router>
              </SnackBarProvider>
            </TranslationProvider>
          </LoadingProvider>
        </>
      );
    }}
  </CacheBuster>
);
